export default __webpack_public_path__ + "static/media/thumbpics2.fd70f9eb.jpg";